import React from "react"
import Container from "../components/Container";
import Head from "../components/Head";
import FooterLogos from "../components/FooterLogos";

const Home = () => {
  return (
    <Container>
      <Head paragraphs={[
        'Créditos de la aplicación',
        'AccessTicket parte de una idea del equipo Primavera Labs, división de I+D+I de \nPrimavera Sound S.L.',
        'Programación: Primavera Labs',
        'Diseño UX+UI: Vasava',
      ]} />


      <FooterLogos />
    </Container>
  )
}

export default Home